import { IColumnsTable } from "./../../interfaces/pages/abm/abm-buscador.interface";
export const AbmModalConfig = {};

// COLUMNS

export const AbmColumnsMantenedorBuscador: IColumnsTable[] = [
  {
    field: "order",
    header: "Orden",
    isSortable: true,
    width: 7
  },
  {
    field: "domain",
    header: "Dominio",
    isSortable: false,
    width: 17,
  },
  {
    field: "subDomain",
    header: "Sub Dominio / Profile",
    isSortable: false,
    width: 17,
  },
  {
    field: "labelDropDown",
    header: "Nombre Visible",
    isSortable: false,
    width: 22,
  },
];

export const AbmColumnsStructConfig: IColumnsTable[] = [
  // { field: "order", header: "Orden", isSortable: false, width: 7 },
  {
    field: "varName",
    header: "Variables Fuentes",
    isSortable: true,
    width: 22,
  },
  {
    field: "varLabel",
    header: "Nombre Visible",
    isSortable: true,
    width: 30,
  },
];
